import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import {
  faArrowDownToLine,
  faBullseyeArrow,
  faChartArea,
  faChartColumn,
  faChartLine,
  faChartLineUp,
  faChartMixed,
  faChartPie,
  faChartPieSimple,
  faChartSimple,
  faChartSimpleHorizontal,
  faEnvelope,
  faFolderUser,
  faGraduationCap,
  faGrid2Plus,
  faGridHorizontal,
  faHouseWindow,
  faMessagesQuestion,
  faNotdef,
  faPeopleGroup,
  faQuestionCircle,
  faRoute,
  faSitemap,
  faSparkles,
  faSquarePollHorizontal,
  faThLarge,
  faUpload,
  faUser,
  faUserFriends,
  faUserGear,
  faUserShield,
} from "@fortawesome/pro-solid-svg-icons";

/** Solid counterparts of the light icons used in the left nav. Imported individually so the
 * bundle only carries these, not the whole solid set. */
const selectedNavIcons: IconDefinition[] = [
  faArrowDownToLine,
  faBullseyeArrow,
  faChartArea,
  faChartColumn,
  faChartLine,
  faChartLineUp,
  faChartMixed,
  faChartPie,
  faChartPieSimple,
  faChartSimple,
  faChartSimpleHorizontal,
  faEnvelope,
  faFolderUser,
  faGraduationCap,
  faGrid2Plus,
  faGridHorizontal,
  faHouseWindow,
  faMessagesQuestion,
  faNotdef,
  faPeopleGroup,
  faQuestionCircle,
  faRoute,
  faSitemap,
  faSparkles,
  faSquarePollHorizontal,
  faThLarge,
  faUpload,
  faUser,
  faUserFriends,
  faUserGear,
  faUserShield,
];

const selectedNavIconsByName = new Map<string, IconDefinition>(
  selectedNavIcons.map((icon) => [icon.iconName, icon]),
);

const navIconHelper = {
  /** The solid version of a nav icon, for the selected item. Falls back to the icon passed
   * in when no solid counterpart has been registered above. */
  getSelectedIcon: function (icon: IconDefinition): IconDefinition {
    return selectedNavIconsByName.get(icon.iconName) ?? icon;
  },
};

export default navIconHelper;
